import React from "react";
import { FlexRow } from "Components/Flex";
import { SvgClock as ClockIcon } from "melodies-source/Svgs/Clock";
import styled from "styled-components";

interface Props {
  label?: string;
}

export const NoData: React.FC<Props> = ({ label = "Insufficient Data" }) => {
  return (
    <StyledFlexRow gap="5px" yCenter xCenter>
      <ClockIcon />
      <span>{label}</span>
    </StyledFlexRow>
  );
};

const StyledFlexRow = styled(FlexRow)`
  color: var(--text-color);
  height: -webkit-fill-available;

  span {
    font-size: 14px;
  }
`;
